import * as React from "react";
import {AnnotationManager} from "../Manager/PDFManager/AnnotationManager";
import {PageManager} from "../Manager/PDFManager/PageManager";
import {DocumentManager} from "../Manager/PDFManager/DocumentManager";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faArrowUp} from "@fortawesome/free-solid-svg-icons/faArrowUp";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons/faArrowDown";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";

import {FontAwesomeIcon as FIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {PDFFieldLayer} from "./PDFFieldLayer";
import './PDFPreview.css';
export class PDFPreview extends React.Component<PDFPreviewProps, PDFPreviewState> {
    static defaultProps: Partial<PDFPreviewProps> = {};

    constructor(props: PDFPreviewProps) {
        super(props);
        this.state = {};
        this.CanvasLoaded=this.CanvasLoaded.bind(this);
    }

    CanvasLoaded(node){
        this.props.DocumentManager.Canvas=node;
        this.props.DocumentManager.RefreshCanvas()
    }
    componentDidMount() {
        this.props.DocumentManager.SelectedPageChanged.Subscribe(this,()=>this.forceUpdate());
    }

    componentWillUnmount() {
        this.props.DocumentManager.SelectedPageChanged.Unsubscribe(this);
    }

    public render() {
        if(this.props.DocumentManager.LoadingPDFError!=null)
        {
            return(
                <h1 style={{textAlign:'center',color:'red',lineHeight:'1em'}}><FIcon icon={faTimes} /> {this.props.DocumentManager.LoadingPDFError}</h1>
            );
        }

        if(this.props.DocumentManager.SelectedPage==null)
            if(this.props.DocumentManager.LoadingPDF)
                return (
                    <h1 style={{textAlign:'center'}}><FIcon icon={faSpinner} spin={true} /> Loading pdf, please wait...</h1>
                )
            else
                return (

                    <h1 style={{textAlign:'center'}}>No pdf to preview yet</h1>
                );
        return (
            <div style={{height:'100%'}}>
                <div style={{backgroundColor:'#efefef',padding:5,borderBottom:'1px solid #bbb',height:36}}>
                    <FontAwesomeIcon className={'pdfGoUp'} icon={faArrowUp} style={{marginRight:7,cursor:'pointer'}} onClick={()=>this.GoDown()}/>
                    <FontAwesomeIcon className={'pdfGoDown'} icon={faArrowDown} style={{marginRight:7,cursor:'pointer'}} onClick={()=>this.GoUp()}/>
                    <input style={{width:50,borderColor:'#dfdfdf',borderStyle:'solid',textAlign:'right'}} value={this.props.DocumentManager.SelectedPage!=null?this.props.DocumentManager.SelectedPage.Index+1:0} onChange={e=>this.GoToPage(e.target.value)}/>
                    <span style={{marginLeft:5}}>of {this.props.DocumentManager.Pages.length}</span>
                </div>
                <div className={'PDFContainer'} style={{border:'1px solid #dfdfdf',padding:10,backgroundColor:'#dfdfdf',overflow:'auto',height:'calc(100% - 36px)'}} >

                    <div style={{textAlign:'center'}}>
                        <div style={{position:'relative',display:'inline-block'}} className={'PDFPreviewContainer'}>
                            <div onMouseDown={e=>this.props.DocumentManager.AddFieldManager.MaybeStartDragging(e)}>
                                <canvas ref={this.CanvasLoaded} style={{display:'block'}}/>
                                <PDFFieldLayer DocumentManager={this.props.DocumentManager}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    private GoUp() {
        if(this.props.DocumentManager.SelectedPage!=null)
            this.props.DocumentManager.SetSelectedPage(this.props.DocumentManager.SelectedPage.Index+1);
    }

    private GoDown() {
        if(this.props.DocumentManager.SelectedPage!=null)
            this.props.DocumentManager.SetSelectedPage(this.props.DocumentManager.SelectedPage.Index-1);
    }

    private GoToPage(value: string) {
        let val=Number(value);
        if(isNaN(val))
            val=1;
        this.props.DocumentManager.SetSelectedPage(val-1);
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PDFPreviewProps {
    SelectedAnnotation:AnnotationManager;
    DocumentManager:DocumentManager;
}

interface PDFPreviewState {

}

//#endregion "My Region"